// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F5OfA","fullView":"styles_fullView__1Qz4Z"};